import script from "./AttackArmorValueGame.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttackArmorValueGame.vue?vue&type=script&setup=true&lang=ts"

import "./AttackArmorValueGame.vue?vue&type=style&index=0&id=17df97ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17df97ca"]])

export default __exports__